module.exports = __webpack_public_path__ + "img/30-Growing slowly.c060a5bc.png";